import Navigation from './Navigation'

import { withRecord } from 'packages/core/hoc/withApp'

export default withRecord('menu')(Navigation)
